import React, { Component } from "react";

import DeleteAnswer from "./delete_answer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import ActionAnswerModal from "./action_modal";

class ActionAnswer extends Component {
  state = { errors: "", openMenu: false };
  render() {
    if (this.props.answer.can_delete === true) {
      return (
        <React.Fragment>
          <div
            style={{
              position: "absolute",
              top: "4px",
              right: "10px",
              cursor: "pointer",
              fontSize: "30px"
            }}
            onClick={this.handleClick}
          >
            ...
          </div>
          {this.renderActionModal()}
        </React.Fragment>
      );
    }

    return <div />;
  }

  renderActionModal() {
    if (this.state.openMenu === true) {
      return (
        <ActionAnswerModal
          handleCloseView={this.closeView}
          editQuestion={this.props.editQuestion}
          answer={this.props.answer}
          removeAnswer={this.props.removeAnswer}
        />
      );
    }
  }

  errorsAPI = errors => {
    this.setState({ errors });
  };

  handleClick = event => {
    event.preventDefault();
    const openMenu = !this.state.openMenu;
    this.setState({ openMenu });
  };

  closeView = e => {
    this.setState({ openMenu: false });
  };
}

export default ActionAnswer;



// WEBPACK FOOTER //
// ./src/components/list/interface/answer/action_answer.jsx